<template>
  <v-container id="online-purchase-table">
    <MaterialCard
      elevation="0"
      color="primary"
      :title="this.$t('title.online_purchases')"
      class="tour-start"
    >
      <base-datatable
        dispatch_get="webshop/getPayments"
        :type="this.$t('label.online_purchases')"
        :header_items="headers"
        :sort_by="sortBy"
        :sort_desc="sortBy"
        view_route="online-purchase-view"
        :custom_sort="customSort"
      ></base-datatable>
    </MaterialCard>
  </v-container>
</template>

<script lang="ts">
import Vue from "vue";
import BaseDatatable from "../../../../../components/views/BaseDatatable.vue";
import { online_purchase_table } from "@/mixins/online_purchase";
import MaterialCard from "../../../../../components/views/MaterialCard.vue";

export default Vue.extend({
  name: "Online-Purchases",
  mixins: [online_purchase_table],
  components: { MaterialCard, BaseDatatable },
  data() {
    return {
      sortBy: ["created_at"]
    };
  },
  methods: {
    customSort(items) {
      return items;
    }
  }
});
</script>
